<template>
  <component :is="pageComponent" />
</template>

<script>
import PcStreaming from "@/views/pc/streaming/index.vue";
import MStreaming from "@/views/mobile/streaming/index.vue";
import { isMobile } from "@/utils/device";

export default {
  name: "StreamingBridge",
  computed: {
    pageComponent() {
      return isMobile() ? MStreaming : PcStreaming;
    },
  },
};
</script>
